/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from 'clsx'
import BookingLoginReservationDetailButton from 'pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/BookingLoginReservationDetailButton'
import { ReceiptPercentIcon, TrashIcon } from '@heroicons/react/24/solid'
import { PackagesCartItemVoucher } from 'types/entities/PackagesCartItemVoucher'
import { useAppDispatch } from 'helpers/store'
import { useTranslation } from 'react-i18next'
import UiAlertConfirmationModal from 'components/Ui/UiAlertConfirmationModal'
import { openModal, closeSecondaryModal, openSecondaryModal } from 'helpers/actions'
import { ModalSize } from 'types/enums/ModalSize'
import { PackagesCart } from 'types/entities/PackagesCart'
import BookingSellerVoucherModal from 'pages/Front/Booking/Seller/BookingSellerReservationDetail/components/BookingSellerVoucherModal'
import { toast } from 'utils/toastUtils'
import SellerAction from 'store/seller/SellerAction'

interface BookingSellerReservationDetailVoucherActionsProps {
    className?: string
    packagesCartItemVoucher: PackagesCartItemVoucher
    packagesCart: PackagesCart
}

const BookingSellerReservationDetailVoucherActions = (
    props: BookingSellerReservationDetailVoucherActionsProps
) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const onRemoveHandler = (
        packagesCartItemVoucher: PackagesCartItemVoucher
    ) => {
        dispatch(
            openSecondaryModal(
                <UiAlertConfirmationModal
                    title={t('Remove voucher')}
                    message={t(
                        'You are about to remove an voucher, only admin can reverse this.'
                    )}
                    onConfirm={() => {
                        onConfirmRemoveHandler(packagesCartItemVoucher)
                        dispatch(closeSecondaryModal())
                    }}
                    onCancel={() => dispatch(closeSecondaryModal())}
                />,
                { modalSize: ModalSize.Small },
                t('Confirm')
            )
        )
    }

    const onConfirmRemoveHandler = (
        packagesCartItemVoucher: PackagesCartItemVoucher
    ) => {
        dispatch(
            SellerAction.fetchDeleteVoucher(
                props.packagesCart.id,
                packagesCartItemVoucher.voucher_id
            )
        ).then((_) => {
            toast.warning(t('Voucher deleted'))
            // dispatch(SellerAction.setReservation(r.reservation));
        })
    }

    const onDiscountHandler = (
        packagesCartItemVoucher: PackagesCartItemVoucher
    ) => {
        dispatch(
            openModal(
                <BookingSellerVoucherModal
                    packagesCartItemVoucher={packagesCartItemVoucher}
                    packagesCart={props.packagesCart}
                />,
                {
                    modalSize: ModalSize.Scrollable,
                }
            )
        )
    }

    return (
        <div
            className={clsx(
                'BookingSellerReservationDetailVoucherActions flex flex-row justify-center gap-x-2',
                props.className
            )}
        >
            <BookingLoginReservationDetailButton
                className={'border-purple-400 bg-purple-400 h-[28px] w-[28px]'}
                onClick={() => onDiscountHandler(props.packagesCartItemVoucher)}
            >
                <ReceiptPercentIcon className={'w-4 h-4 flex-none'} />
            </BookingLoginReservationDetailButton>
            <BookingLoginReservationDetailButton
                className={'border-red-400 bg-red-400 h-[28px] w-[28px]'}
                onClick={() => onRemoveHandler(props.packagesCartItemVoucher)}
            >
                <TrashIcon className={'w-4 h-4 flex-none'} />
            </BookingLoginReservationDetailButton>
        </div>
    )
}

export default BookingSellerReservationDetailVoucherActions
